<template>
    <div class="warpper">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="input-form">
            <div class="flex align-center justify-between">
                <h3 class="page-title line-height">分支机构基本信息 <span>新录入分支机构账号和初始密码均为联系人手机号</span></h3>
                <el-button class="blue-btn" round type="primary" @click="$router.go(-1)">返回</el-button>
            </div>
            <el-form-item ref="morglogo" class="form-row-item flex align-center margin-tb-sm" label="单位LOGO"
                          prop="morglogo">
                <el-upload
                    :action="`${ONLINEHOST_EMOF}home/User/imgthumb`"
                    :data="fileData"
                    :name="'image'"
                    :on-success="handleAvatarSuccess"
                    :show-file-list="false"
                    accept="image/*"
                    class="avatar-uploader margin-left"
                >
                    <div class="flex align-center">
                        <el-image v-if="ruleForm.morglogo" :src="ruleForm.morglogo" class="logo "></el-image>
                        <div v-else class="logo up">点击上传</div>
                        <div slot="tip" class="el-upload__tip margin-left">推荐尺寸大小120px*120px,5M以内</div>
                    </div>
                </el-upload>
            </el-form-item>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="morgname" class="input-container" label="单位名称" labelWidth="100px"
                                  prop="morgname">
                        <el-input v-model="ruleForm.morgname" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="rankId" class="input-container" label="分支机构等级" labelWidth="100px" prop="rankId">
                        <el-select v-model="ruleForm.rankId" placeholder="请选择分支机构等级">
                            <el-option
                                v-for="item in levelList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="contacts" class="input-container" label="联系人" labelWidth="100px" prop="contacts">
                        <el-input v-model="ruleForm.contacts" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="morgtel" class="input-container" label="联系电话" labelWidth="100px" prop="morgtel">
                        <el-input v-model="ruleForm.morgtel" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item ref="address" class="input-container" label="单位地址" labelWidth="100px" prop="address">
                        <el-input v-model="ruleForm.address" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="morgemail" class="input-container" label="邮箱" labelWidth="100px"
                                  prop="morgemail">
                        <el-input v-model="ruleForm.morgemail" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="morgurl" class="input-container" label="网址" labelWidth="100px" prop="morgurl">
                        <el-input v-model="ruleForm.morgurl" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row :gutter="20" v-if="false">
                <el-col :span="12">
                    <el-form-item label="分支机构聘书编号" labelWidth="100px" >
                        <el-input v-model="ruleForm.pinshu_code" placeholder="请输入分支机构聘书编号"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="page-title margin-tb-sm">分支机构介绍</div>

            <el-form-item ref="morgdesc" class="margin-bottom-sm" label="单位介绍" labelWidth="90px" prop="morgdesc">
                <div class="input-container padding-xs">
                    <VueUditorWrap v-model="ruleForm.morgdesc" :config="myConfig"></VueUditorWrap>
                </div>
            </el-form-item>
            <div class="info-container margin-bottom-sm flex-sub">
                <div class="flex align-start justify-between margin-bottom-sm">
                    <div class="page-title">积分信息</div>
                    <!--                <el-button v-if="examine_status !== 2" class="blue-btn" round type="primary"-->
                    <!--                           @click="shoaAddPay">添加积分-->
                    <!--                </el-button>-->
                </div>
                <div class="ship-list flex flex-direction align-center">
                    <el-table
                        :data="integrals"
                        border
                        header-row-class-name="table-header"
                        style="width: 100%;border-radius: 10px">
                        <el-table-column label="序号" prop="name">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ (page - 1) * limit + scope.$index + 1 }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="积分" prop="integral">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ scope.row.integral }}分
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="获取时间" prop="create_time">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ scope.row.create_time }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="获取途径" prop="integral_type_name">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ scope.row.integral_type_name }}
                                </div>
                            </template>
                        </el-table-column>
                        <!--                    <el-table-column v-if="examine_status !== 2" label="操作" prop="end_time">-->
                        <!--                        <template slot-scope="scope">-->
                        <!--                            <div class="table-name">-->
                        <!--                                <el-button style="color: #e4393c" type="text" @click="delItem(scope.row.id)">删除-->
                        <!--                                </el-button>-->
                        <!--                            </div>-->
                        <!--                        </template>-->
                        <!--                    </el-table-column>-->
                    </el-table>
                    <el-pagination
                        :current-page.sync="page"
                        :page-size="limit"
                        :total="integral_tatal"
                        background
                        class="page-all margin-top"
                        layout="prev, pager, next, jumper"
                        @current-change="getIntegralDetail">
                    </el-pagination>
                </div>
            </div>
            <div class="flex align-center justify-center margin-tb">
                <el-button :loading="loading" class="input-form-btn" type="primary"
                           @click="submitForm('ruleForm')">保存
                </el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig} from "@/utils/utils"
import rules from "@/utils/rules";
import {createOrgFenHui, getRankList, showOrgFenHui} from '@/api/organiz'
// import {baseURL} from "@/config";
import {img_url} from "@/utils/const";
import {getIntegralDetail} from "../../../../api/member";
import {ONLINEHOST_EMOF} from "@/config";

export default {
    morgname: "info",
    data() {
        return {
            ONLINEHOST_EMOF:ONLINEHOST_EMOF,
            myConfig: bdEditConfig(),
            baseURL: img_url,
            id: '',
            ruleForm: {
                morglogo: '',
                morgname: '',
                rankId: '',
                contacts: '',
                morgtel: '',
                address: '',
                morgemail: '',
                morgurl: '',
                pinshu_code: '',
                morgdesc: '',
            },
            rules: {
                // morglogo: [{required: true, message: "请上传单位LOGO", trigger: "change"}],
                morgname: [
                    {required: true, message: '请输入单位名称', trigger: 'blur'}
                ],
                rankId: [{required: true, message: "请选择分支机构等级", trigger: "change"}],
                contacts: [
                    {required: true, message: '请输入联系人', trigger: 'blur'}
                ],
                morgtel: rules.tel,
                // address: [
                //     {required: true, message: '请输入地址', trigger: 'blur'}
                // ],
                morgemail: [
                    // {required: true, message: '请输入邮箱地址', trigger: 'blur'},
                    {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}
                ],
                morgurl: [
                    rules.webUrl
                ],
                // morgurl: [
                //   {required: true, message: '请输入网址', trigger: 'blur'}
                // ],
                // morgdesc: [
                //   {required: true, message: '请输入单位介绍', trigger: 'blur'}
                // ],

            },
            levelList: [],
            loading: false,

            integrals: [],
            integral_tatal: 0,
            page: 1,
            limit: 5
        }
    },
    computed: {
        fileData() {
            return {
                mid: this.$store.state.user.emofUserTokenSafer
            }
        },
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [8, 0], '分支机构编辑')
        this.id = this.$route.params.id || ''
        this.getRankList()
        if (Number(this.id)) this.init()
    },
    components: {VueUditorWrap},
    methods: {
        async init() {
            let _data = await showOrgFenHui(this.id)
            if (_data.status === 200) {
                this.ruleForm = {
                    morglogo: _data.data.logo,
                    morgname: _data.data.name,
                    rankId: _data.data.rank_id || '',
                    contacts: _data.data.lianxiren,
                    morgtel: _data.data.lianxidianhua,
                    address: _data.data.addresss,
                    morgemail: _data.data.email,
                    morgurl: _data.data.website,
                    morgdesc: _data.data.desc,
                    pinshu_code: _data.data.pinshu_code,
                }
            }
            this.getIntegralDetail()
        },
        async getIntegralDetail() {
            let _data = await getIntegralDetail(this.user.mid,this.id,2,this.page,this.limit)
            this.integrals = _data.data
            this.integral_tatal = _data.count
        },
        submitForm(formName) {

            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    this.submitChange();
                } else {
                    let error = Object.values(validates).shift().shift()
                    let dom = this.$refs[error.field]
                    this.$confirm(error.message, "提示", {
                        confirmButtonText: "确定",
                        showCancelButton: false,
                        type: "warning",
                    }).then(() => {
                        dom.$el.scrollIntoView({
                            block: 'center', // 当前元素显示在视图区域中间
                            behavior: 'auto' // 滚动速度
                        })
                    })
                }
            });
        },
        async submitChange() {
            this.loading = true
            let _data = await createOrgFenHui(this.id, this.ruleForm.morglogo, this.ruleForm.morgname,
                this.ruleForm.rankId,this.ruleForm.contacts, this.ruleForm.morgtel, this.ruleForm.address,
                this.ruleForm.morgemail, this.ruleForm.morgurl, this.ruleForm.morgdesc,this.ruleForm.pinshu_code)
            this.loading = false
            if (_data.status === 200) {
                if (this.id) {
                    this.$message.success('保存成功')
                } else {
                    this.$message.success('添加成功')
                }
                this.$router.go(-1)
            }
        },
        //  获取等级列表
        async getRankList() {
            let _list = await getRankList(2)
            this.levelList = _list.data
        },
        handleAvatarSuccess(res) {
            if (res.status === 200) {
                this.ruleForm.morglogo = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px 30px;
    .el-select{
        width: 100%;
    }
    .logo {
        width: 80px;
        height: 80px;
        border-radius: 80px;

        &:hover {
            border: 1px dotted #fc7802;
        }

        &.up {
            border: 1px dotted #999999;
            line-height: 80px;
            text-align: center;
        }
    }

    .morgdesc {
        border-radius: 10px;
        border: solid 1px #dae0e6;
        padding: 12px;
    }

    .input-form-btn {
        width: 200px;
        height: 40px;
        line-height: 40px;
        border-radius: 40px;
        font-size: 16px;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#ff9600, #ff9600);
        background-blend-mode: normal, normal;
        color: #ffffff;
        margin-top: 20px;
        padding: 0;

        &.white {
            background: #ffffff none;
            color: #ff9600;
        }
    }
}
.table-name {
    font-size: 16px;
    color: #0a2240;
    text-align: center;
}
.page-title {
    span {
        font-size: 14px;
        font-weight: normal;
    }
}
</style>
